export default __webpack_public_path__ + "static/media/fake3.705b37a2.jpg";